
import Store from './component';
import mainReducer from './reducer';


export const initialState = {elementId: window.uuidv4()};
export const reducer = mainReducer;
export const component = Store;
